import { usePlatformService } from 'core';
import { useAtom } from 'jotai';
import { ButtonMantine, Group, ImageMantine, Modal, Stack, Text } from 'ui';

import { holidayExtensionModalAtom } from '../atoms';

const ModalContent = () => {
  const Platform = usePlatformService();
  const title = Platform.select({
    default: 'Download the desktop browser extension',
    mobileBrowser: 'Download the Givebacks app to enable the extension',
    native: 'Enable the mobile browser extension',
  });

  const subtitle = Platform.select({
    default:
      'Once you get the extension, Givebacks will donate $5 on your behalf for kids in foster care.',
    mobileBrowser:
      'Once you download the app and enable the extension, Givebacks will donate $5 on your behalf for kids in foster care.',
    native:
      'Once you get the extension, Givebacks will donate $5 on your behalf for kids in foster care.',
  });

  const cta = Platform.select({
    default: 'Get Extension',
    mobileBrowser: 'Get the App',
  });

  const action = Platform.select({
    default: () => window.open('https://api.givebacks.com/magic', '_blank'),
    // TODO: Remove this page as it's no longer used
  });

  return (
    <Stack gap={'xl'}>
      <Stack gap={'xs'}>
        <Text fz={24} fw={600}>
          {title}
        </Text>
        <Text c={'gray.6'} fz={14} fw={400}>
          {subtitle}
        </Text>
      </Stack>

      <ButtonMantine onClick={() => action()}>{cta}</ButtonMantine>
    </Stack>
  );
};
const ExtensionModal = () => {
  const [opened, setExtensionModal] = useAtom(holidayExtensionModalAtom);
  return (
    <Modal
      opened={opened}
      onClose={() => setExtensionModal(false)}
      title={
        <Group justify="center" style={{ flexGrow: 1, marginLeft: 'auto', marginRight: 'auto' }}>
          <ImageMantine
            src="https://s3.us-east-1.amazonaws.com/com.givebacks.public/images/holidayPromotion/extension-modal.png"
            w={64}
          />
        </Group>
      }
      styles={{ title: { width: '100%' } }}
    >
      <ModalContent />
    </Modal>
  );
};

export { ExtensionModal };
